import React, { useState } from "react";
import iconPlus from "../assets/images/Icon-plus.svg";
import iconTrash from "../assets/images/icon-trash.svg";
import iconMinus from "../assets/images/icon-minus.svg";
import iconChevronDown from "../assets/images/icon-chevron-down.svg";
import iconChevronUp from "../assets/images/icon-chevron-up.svg";
import Chicken from "../assets/images/chicken.png";
import "./CardOpen.css";

const DEFAULT_SIDE_OPTIONS = [
  "Riz « frit » et légumes du marché",
  "Patates douces et légumes",
  "Légumes seulements ( +0,95 $ )",
];

const DEFAULT_SIZE_OPTIONS = ["Régulier", "Familial", "Petit"];

function newSelection(sideOptions, sizeOptions) {
  return { side: sideOptions[0], size: sizeOptions[0] };
}

export default function CardOpen({
  image = Chicken,
  title = "Hauts de cuisse de poulet grillés miel et ail",
  tags = [
    { label: "Grillé", variant: "default" },
    { label: "Protéines", variant: "default" },
    { label: "Format familial", variant: "highlight" },
  ],
  quantity = 1,
  sideOptions = DEFAULT_SIDE_OPTIONS,
  sizeOptions: customSizeOptions,
  onIncrement,
  onDecrement,
  onSelectionsChange,
  onInfoClick,
}) {
  const hasFamilyTag =
    tags && tags.some((tag) => tag.label === "Format familial");

  const sizeOptions =
    customSizeOptions ||
    (hasFamilyTag
      ? DEFAULT_SIZE_OPTIONS
      : DEFAULT_SIZE_OPTIONS.filter((size) => size !== "Familial"));

  // One selection object per meal: { side, size }
  const [selections, setSelections] = useState(
    Array.from({ length: quantity }, () =>
      newSelection(sideOptions, sizeOptions),
    ),
  );

  // Keep selections array in sync when quantity changes from outside
  const prevQty = React.useRef(quantity);
  React.useEffect(() => {
    if (quantity > prevQty.current) {
      setSelections((prev) => {
        const next = [...prev, newSelection(sideOptions, sizeOptions)];
        if (onSelectionsChange) onSelectionsChange(next);
        return next;
      });
    } else if (quantity < prevQty.current) {
      setSelections((prev) => {
        const next = prev.slice(0, quantity);
        if (onSelectionsChange) onSelectionsChange(next);
        return next;
      });
      setOpenDropdown(null);
    }
    prevQty.current = quantity;
  }, [quantity, sideOptions, sizeOptions]);

  // Which dropdown is open: { row: number, type: 'side' | 'size' } | null
  const [openDropdown, setOpenDropdown] = useState(null);

  const isOpen = (row, type) =>
    openDropdown && openDropdown.row === row && openDropdown.type === type;

  const toggleDropdown = (row, type) => {
    setOpenDropdown((prev) =>
      prev && prev.row === row && prev.type === type ? null : { row, type },
    );
  };

  const pickOption = (row, type, value) => {
    setSelections((prev) => {
      const next = prev.map((sel, i) =>
        i === row ? { ...sel, [type]: value } : sel,
      );
      if (onSelectionsChange) onSelectionsChange(next);
      return next;
    });
    setOpenDropdown(null);
  };

  const handleIncrement = () => onIncrement && onIncrement();
  const handleDecrement = () => onDecrement && onDecrement();

  return (
    <div className="card-open">
      <div className="card-children">
        <div
          className="co-image"
          onClick={onInfoClick}
          style={onInfoClick ? { cursor: "pointer" } : {}}
        >
          <img src={image} alt={title} className="co-image-photo" />
          <div className="co-image-overlay" />
          <span className="co-image-qty">{quantity}</span>
        </div>
        <div className="card-content">
          <p className="co-title">{title}</p>

          <div className="co-tags">
            {tags.map((tag, i) => (
              <span
                key={i}
                className={`co-tag${tag.variant === "highlight" ? " co-tag--highlight" : ""}`}
              >
                {tag.label}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="co-counter">
        <button
          className="co-counter-btn"
          onClick={handleDecrement}
          aria-label="Supprimer"
        >
          <img src={quantity > 1 ? iconMinus : iconTrash} alt="" />
        </button>
        <span className="co-counter-qty">{quantity}</span>
        <button
          className="co-counter-btn"
          onClick={handleIncrement}
          aria-label="Ajouter"
        >
          <img src={iconPlus} alt="" />
        </button>
      </div>

      {/* One dropdown row per meal */}
      <div className="co-rows">
        {selections.map((sel, row) => (
          <div key={row} className="co-options">
            {/* ── Side dish ── */}
            <div className="co-selector co-selector--wide">
              <button
                className="co-option co-option--wide"
                onClick={() => toggleDropdown(row, "side")}
              >
                <span>{sel.side}</span>
                <img
                  src={isOpen(row, "side") ? iconChevronUp : iconChevronDown}
                  alt=""
                />
              </button>
              {isOpen(row, "side") && (
                <div className="co-dropdown">
                  {sideOptions.map((opt, i) => (
                    <button
                      key={i}
                      className={`co-dropdown-item${opt === sel.side ? " co-dropdown-item--active" : ""}`}
                      onClick={() => pickOption(row, "side", opt)}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* ── Size ── */}
            <div className="co-selector">
              <button
                className="co-option"
                onClick={() => toggleDropdown(row, "size")}
              >
                <span>{sel.size}</span>
                <img
                  src={isOpen(row, "size") ? iconChevronUp : iconChevronDown}
                  alt=""
                />
              </button>
              {isOpen(row, "size") && (
                <div className="co-dropdown co-dropdown--right">
                  {(() => {
                    const isFirstSideSelected =
                      sel.side === DEFAULT_SIDE_OPTIONS[0];
                    const allowFamilySize = hasFamilyTag && isFirstSideSelected;
                    const currentAvailableSizes = allowFamilySize
                      ? sizeOptions
                      : sizeOptions.filter((size) => size !== "Familial");

                    return currentAvailableSizes.map((opt, i) => (
                      <button
                        key={i}
                        className={`co-dropdown-item${opt === sel.size ? " co-dropdown-item--active" : ""}`}
                        onClick={() => pickOption(row, "size", opt)}
                      >
                        {opt}
                      </button>
                    ));
                  })()}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
